/**
 * External dependencies
 */
import { __ } from '@web-stories-wp/i18n';

/**
 * Internal dependencies
 */

import { TEXT_SHADOW_STYLE, TEXT_SHADOW_TARGET } from '../../../../constants';

export const MIN_MAX = {
  BLUR: {
    MIN: 0,
    MAX: 100,
  },
  COORDINATES: {
    MIN: -500,
    MAX: 500,
  },
};

export const SHADOW_OPTIONS = [
  { id: TEXT_SHADOW_STYLE.NONE, label: __('None', 'web-stories') },
  {
    id: TEXT_SHADOW_TARGET.TEXT,
    label: __('Text', 'web-stories'),
  },
  {
    id: TEXT_SHADOW_TARGET.TEXT_BOX,
    label: __('Text box', 'web-stories'),
  },
];

export const TEXT_ONLY_SHADOW_OPTIONS = SHADOW_OPTIONS.filter(
  ({ id }) => id !== TEXT_SHADOW_TARGET.TEXT_BOX
);
